import { Outlet } from 'react-router-dom'
import { Suspense, useCallback, useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import ErrorBoundary from '@/components/ErrorBoundary'
import CustomerInboxPopup from '@/components/CustomerInboxPopup'

// Page-level loading spinner (smaller, inside content area)
const PageLoader = () => (
  <div className="flex items-center justify-center h-full">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      <p className="text-muted-foreground text-sm">Loading...</p>
    </div>
  </div>
)

export default function DashboardLayout() {
  // Mobile off-canvas drawer state. On desktop the sidebar is always visible
  // (md:static) so this only governs the phone/tablet overlay.
  const [mobileOpen, setMobileOpen] = useState(false)
  const closeMobile = useCallback(() => setMobileOpen(false), [])

  return (
    <div className="flex h-screen bg-slate-50">
      {/* Sidebar — persistent on desktop, off-canvas drawer on mobile */}
      <Sidebar mobileOpen={mobileOpen} onClose={closeMobile} />

      {/* Main content area — overflow-y-hidden keeps vertical scroll contained
          to the inner <main>, while allowing absolutely-positioned children
          (dropdowns, popovers) to escape horizontally without being clipped. */}
      <div className="flex flex-col flex-1 overflow-y-hidden min-w-0">
        {/* Header */}
        <Header onMenuClick={() => setMobileOpen(true)} />

        {/* Page content */}
        <main className="flex-1 overflow-auto p-6 bg-slate-50">
          <ErrorBoundary>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>

      {/* Auto-popup when new customer feedback / product requests arrive */}
      <CustomerInboxPopup />
    </div>
  )
}
